<template>
  <app-page
    :title="employee ? $t('employee.rehire.title', { name: employee.full_name }) : $t('employee.rehire.titleFallback')"
    :error="error"
    :previous="[
      { label: $t('employee.previousLabel'), to: { name: 'employees' } },
      {
        label: employee ? employee.full_name : $t('employee.title'),
        to: { name: 'employee', params: { employeeId: $route.params.employeeId } },
      },
    ]"
    icon="user-plus"
  >
    <app-loading :loading="loading" />
    <template v-if="!loading && !saved">
      <!-- Guards the page itself, not just the button, so pasting the URL for an employee
           whose termination came from the integration can't reach the action. -->
      <sme-alert v-if="unavailableReason" level="warning">{{ unavailableReason }}</sme-alert>
      <template v-else>
        <sme-alert level="warning">
          {{ $t('employee.rehire.warningAlert', { name: employee.full_name }) }}
        </sme-alert>
        <page-sub-footer>
          <b-button data-testid="rehire-button" @click="onRehire" variant="primary" :disabled="saving">
            <b-spinner v-if="saving" class="mr-2" small />
            {{ saving ? $t('employee.rehire.submittingButton') : $t('employee.rehire.submitButton') }}
          </b-button>
        </page-sub-footer>
      </template>
    </template>
    <sme-alert v-if="saved" level="good">
      <p>
        <strong>{{ $t('employee.rehire.rehiredTitle', { name: employee.full_name }) }}</strong>
      </p>
      <p v-if="newStateLabel">{{ $t('employee.rehire.reactivatedBody', { state: newStateLabel }) }}</p>
      <p v-if="newState === EMPLOYEE_STATE.PENDING">
        {{ $t('employee.rehire.pendingBankingBody') }}
      </p>
    </sme-alert>
  </app-page>
</template>

<script>
import ApiClient from '@/ApiClient';
import AppLoading from '@/components/AppLoading.vue';
import AppPage from '@/components/AppPage.vue';
import PageSubFooter from '@/components/PageSubFooter.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import { toTitleCase } from '@/utils/common';
import { EMPLOYEE_STATE, getRehireUnavailableReason } from '@/utils/Employee';

export default {
  name: 'EmployeeRehire',
  components: { AppLoading, AppPage, PageSubFooter, SmeAlert },
  data() {
    return {
      EMPLOYEE_STATE,
      loading: true,
      saving: false,
      saved: false,
      error: undefined,
      employee: undefined,
      newState: undefined,
    };
  },
  computed: {
    newStateLabel() {
      return toTitleCase(this.newState);
    },
    unavailableReason() {
      return getRehireUnavailableReason(this.employee);
    },
  },
  methods: {
    async onRehire() {
      this.saving = true;

      try {
        const result = await ApiClient.employeeReverseUnenrolment(this.employee.employee_id);
        this.newState = result?.new_state;
        this.saved = true;
      } catch (error) {
        this.error = error.message;
      }

      this.saving = false;
    },
    loadData() {
      this.loading = true;
      ApiClient.getEmployee(this.$route.params.employeeId).then(
        employee => {
          this.employee = employee;
          this.loading = false;
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
